import { memo } from 'react';
import { Box, LoadingCircle, TColor } from '@bridebook/ui';
import styles from './loading-spinner.style';

interface IProps {
  size?: number;
  color?: TColor;
}
const LoadingSpinner = ({ size = 50, color = 'indigoCrush' }: IProps) => (
  <Box style={styles.wrapper}>
    <Box style={styles.rotatingAnimation}>
      <LoadingCircle size={size} color={color} animate={false} />
    </Box>
  </Box>
);

export default memo(LoadingSpinner);
